angular.module('intranetApp')
.config(['flowFactoryProvider', function (flowFactoryProvider) {
        
    var metas = document.getElementsByTagName('meta'); 
    var csrfToken;
    
    for (i=0; i<metas.length; i++) { 
       if (metas[i].getAttribute("name") === "csrf-token") { 
          csrfToken = metas[i].getAttribute("content"); 
       } 
    }
    
    console.log(csrfToken);
    flowFactoryProvider.defaults = {
        target: '/documents/upload',
        query: { 
            _token: csrfToken
        }
    };

    // Can be used with different implementations of Flow.js
    // flowFactoryProvider.factory = fustyFlowFactory;
}]);



//# sourceMappingURL=app.flow.config.js.map
